import { EditPageOrBlogV2Route } from './EditPageOrBlogV2Route';

import { getCompanyHubEditRoute } from '@confluence/ssr-app/entry-points/routes';

export const CompanyHubEditRoute = getCompanyHubEditRoute(EditPageOrBlogV2Route);
